module.exports = __webpack_public_path__ + "img/simulation-exams.006a97c0.png";